import React from 'react';

import ActivityTableBulkForm from './form';
import { useLogic } from './logic';

import type { ValuesBulkCommentSubmit } from './form/validation-schema';

interface IProps {
  patientGuid: string;
  open: boolean;
  onClose: () => void;
  activityCount: number;
}

const ActivityTableBulkModal: React.FC<IProps> = (props) => {
  const { patientGuid, open, onClose, activityCount } = props;

  const {
    generatedComment,
    submitError,
    onCancelForm,
    onGenerateComment,
    onSubmit,
    commentLoading,
    reviewLoading,
    Alert,
    MonthlyInteractionAlert,
  } = useLogic({
    patientGuid,
    onClose,
    activityCount,
  });

  return (
    <>
      <ActivityTableBulkForm
        open={open}
        onSubmit={onSubmit}
        onGenerateComment={onGenerateComment}
        onCancelForm={onCancelForm}
        defaultValues={{ patientGuid, comment: '' } as ValuesBulkCommentSubmit}
        generatedComment={generatedComment}
        submitError={submitError}
        commentLoading={commentLoading}
        reviewLoading={reviewLoading}
      />
      {Alert}
      {MonthlyInteractionAlert}
    </>
  );
};

export default ActivityTableBulkModal;
